<template>
  <v-container grid-list-md>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap="">
        <v-flex v-for="user in users" :key="user.UserID" xs12 md6 lg4 xl3>
          <v-card class="card" @click.native="viewUser(user)">
            <v-card-text>
              <v-layout row wrap="">
                <v-flex md3>
                  <v-avatar :size="75" color="grey lighten-4">
                    <img :src="getAvatarUrl(user)" alt="avatar">
                  </v-avatar>
                </v-flex>
                <v-flex md9>
                  <div class="user-info">
                    <div class="name">{{ user.LastName }}, {{ user.FirstName }}</div>
                    <div>{{ user.Email }}</div>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <!-- <v-flex v-for="i in 13" :key="`2${i}`" xs6 md2>
          <v-card dark class="status-failed">
            <v-card-text>
              <div>Action Failed</div>
              <div>Date</div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex v-for="i in 13" :key="`3${i}`" xs6 md2>
          <v-card dark class="status-inactive">
            <v-card-text>
              <div>Action Inactive</div>
              <div>Date</div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex v-for="i in 13" :key="`4${i}`" xs6 md2>
          <v-card dark class="status-good">
            <v-card-text>
              <div>Action Good</div>
              <div>Date</div>
              </v-card-text>
          </v-card>
        </v-flex>-->
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import axios from 'axios';
import RestService from '../services/RestService';
import * as Sentry from '@sentry/browser';

const service = new RestService();

export default {
  name: 'Dashboard',
  props: {
    msg: String
  },
  data() {
    return {
      users: []
    };
  },
  methods: {
    viewUser(user) {
      console.log(user);
    },
    getAvatarUrl(user) {
      return 'https://api.adorable.io/avatars/282/' + user.UserID;
    }
  },
  created() {
    service
      .getAllUsers()
      .then(response => {
        console.log(response.data);
        this.users = response.data.body;
      })
      .catch(e => {
        console.log(e);
        Sentry.captureException(e);
      });
    // service
    //   .getUserActions(100001)
    //   .then(response => {
    //     console.log(response.data);
    //     this.users = response.data;
    //   })
    //   .catch(e => {
    //     console.log(e);
    //   });
    // service
    //   .test(100001)
    //   .then(response => {
    //     console.log(response.data);
    //     this.users = response.data;
    //   })
    //   .catch(e => {
    //     console.log(e);
    //   });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.card {
  background-color: #fff;
}
.status-failed {
  background-color: $color-status-failed;
  border-color: $color-status-failed;
}
.status-inactive {
  background-color: $color-status-inactive;
  border-color: $color-status-inactive;
}
.status-good {
  background-color: $color-status-good;
  border-color: $color-status-good;
}
.user-info {
  height: 100%;
  flex-direction: column;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.name {
  font-weight: 700;
  font-size: 20px;
  text-transform: uppercase;
}
</style>
